/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
// Material-UI components
import Typography from '@mui/material/Typography';

export default function FormSectionHeader(props) {
  const { title, description } = props;

  return (
    <div className='w-full'>
      <Typography variant='body1' className="text-xl">{title}</Typography>
      <Typography variant='body1'>{description}</Typography>
    </div>
  );
}